export default "__VITE_ASSET__B8V8MIzT__"